<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  hasCriteria: boolean
  isLoading: boolean
  hasFailed: boolean
  shownCount: number
  totalCount: number
  noResultsText: string
}>()

const countText = computed(() => {
  const resultWord = props.shownCount === 1 ? 'result' : 'results'
  const shownResults = `${props.shownCount} ${resultWord}`
  const isTruncated = props.totalCount > props.shownCount
  if (isTruncated) {
    return `Found more than ${shownResults}`
  }
  return `Found ${shownResults}`
})
</script>

<template>
  <div class="mb-4">
    <slot v-if="!hasCriteria" name="tips" />
    <div v-else-if="hasFailed" role="alert" class="rounded-xs bg-red-100 p-3 text-text-md text-red-400">
      Something went wrong while searching. Please reload the page to try again.
    </div>
    <p v-else-if="isLoading" role="status" class="text-text-md text-gray-700">Loading...</p>
    <div v-else-if="shownCount === 0" role="status" class="rounded-xs bg-blue-200 p-3 text-text-md text-blue-500">
      {{ noResultsText }}
    </div>
    <p v-else role="status" class="text-text-sm text-gray-700">{{ countText }}</p>
  </div>
</template>
